import { createEntityAdapter } from '@reduxjs/toolkit'
import type { LocalLayer } from './types'

/** Adapter for current (working) layer state */
export const currentLayerAdapter = createEntityAdapter<LocalLayer>()

/** Adapter for original (server snapshot) layer state */
export const originalLayerAdapter = createEntityAdapter<LocalLayer>()
